import { render, staticRenderFns } from "./EditResellerProductComponent.vue?vue&type=template&id=8548145e&"
import script from "./EditResellerProductComponent.vue?vue&type=script&lang=js&"
export * from "./EditResellerProductComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports